export const number_decimal_keys = [
    'Cost',
    'Weight',
    'DefaultConversionFactor',
    'Length',
    'Width',
    'Thickness',
    'SafetyStock-H_SKO',
    'SafetyStock-H_MAR',
    'SafetyStock-H_ULR',
    'SafetyStock-SKO',
    'SafetyStock-BAR',
    'SafetyStock-ARN',
    'SafetyStock-HUD"',
    'PCE',
    'MM',
    'M',
    'M2',
    'M3',
    'KG',
    'TON',
    'BAG',
    'PALLET',
    'PALL',
    'MTR',
    'PALL',
    'KILO',
    'MILLI_M',
    'DefaultConversionFactor',
    'DisplayConversionFactor',
    'ExtraConversionFactor',
    'Fraction-Value1',
    'Fraction-Value2',
    'QtyPackage',
    'Price',
    'ComparePrice',
    'CreditLimit',
    'Debt',
].map((m) => m.toLowerCase());
export const number_integer_keys = ['MonitorStatus', 'LeadTime', 'CustomerDiscountCat', 'MaxDeliveryTime', 'HasDiscount'].map((m) => m.toLowerCase());
export const boolean_keys = ['CreditVerified', 'Blocked', 'AcceptTerms', 'ApplyForInvoice'].map((m) => m.toLowerCase());
export const json_keys = ['DiscountDifferenceData'].map((m) => m.toLowerCase());
export const list_single_line_text_field_keys = ['ProductsWithDiscount'].map((m) => m.toLowerCase());
export const list_product_reference_keys = ['Products'].map((m) => m.toLowerCase());
export const SHOPIFY_ID_PREFIX = 'gid://shopify/';
export const PRODUCT_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Product/`;
export const PRODUCT_VARIANT_ID_PREFIX = `${SHOPIFY_ID_PREFIX}ProductVariant/`;
export const LOCATION_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Location/`;
export const CUSTOMER_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Customer/`;
export const INVENTORYITEM_ID_PREFIX = `${SHOPIFY_ID_PREFIX}InventoryItem/`;
export const METAFIELD_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Metafield/`;
export const METAFIELDDEFINITION_ID_PREFIX = `${SHOPIFY_ID_PREFIX}MetafieldDefinition/`;
export const WEBHOOKSUBSCRIPTION_ID_PREFIX = `${SHOPIFY_ID_PREFIX}WebhookSubscription/`;
export const METAOBJECT_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Metaobject/`;
export const MEDIAIMAGE_ID_PREFIX = `${SHOPIFY_ID_PREFIX}MediaImage/`;
export const COMPANY_LOCATION_CATALOG_PREFIX = `${SHOPIFY_ID_PREFIX}CompanyLocationCatalog/`;
export const PUBLICATION_ID_PREFIX = `${SHOPIFY_ID_PREFIX}Publication/`;
export const COMPANY_PREFIX = `${SHOPIFY_ID_PREFIX}Company/`;
export const DRAFTORDER_PREFIX = `${SHOPIFY_ID_PREFIX}DraftOrder/`;
export const DISCOUNT_AUTOMATIC_NODE_PREFIX = `${SHOPIFY_ID_PREFIX}DiscountAutomaticNode/`;
export const DELIVERY_CUSTOMIZATION_PREFIX = `${SHOPIFY_ID_PREFIX}DeliveryCustomization/`;
export const PAYMENT_CUSTOMIZATION_PREFIX = `${SHOPIFY_ID_PREFIX}PaymentCustomization/`;
export const COLLECTION_PREFIX = `${SHOPIFY_ID_PREFIX}Collection/`;
export const PREFIXES = {
    PRODUCT: PRODUCT_ID_PREFIX,
    PRODUCT_VARIANT: PRODUCT_VARIANT_ID_PREFIX,
    LOCATION: LOCATION_ID_PREFIX,
    CUSTOMER: CUSTOMER_ID_PREFIX,
    INVENTORYITEM: INVENTORYITEM_ID_PREFIX,
    METAFIELD: METAFIELD_ID_PREFIX,
    METAFIELDDEFINITION: METAFIELDDEFINITION_ID_PREFIX,
    WEBHOOKSUBSCRIPTION: WEBHOOKSUBSCRIPTION_ID_PREFIX,
    METAOBJECT: METAOBJECT_ID_PREFIX,
    MEDIAIMAGE: MEDIAIMAGE_ID_PREFIX,
    COMPANY_LOCATION_CATALOG: COMPANY_LOCATION_CATALOG_PREFIX,
    PUBLICATION: PUBLICATION_ID_PREFIX,
    COMPANY: COMPANY_PREFIX,
    DRAFTORDER: DRAFTORDER_PREFIX,
    DISCOUNT_AUTOMATIC_NODE: DISCOUNT_AUTOMATIC_NODE_PREFIX,
    DELIVERY_CUSTOMIZATION: DELIVERY_CUSTOMIZATION_PREFIX,
    PAYMENT_CUSTOMIZATION: PAYMENT_CUSTOMIZATION_PREFIX,
    COLLECTION: COLLECTION_PREFIX,
};
export const ApplyPrefix = (prefix, id) => id ? (id.toString().startsWith(PREFIXES[prefix]) ? id : `${PREFIXES[prefix]}${id}`) : undefined;
